import * as React from "react";
import {useEffect, useState} from "react";
import {AppContext} from "../../context/AppContext";
import {Article} from "../../model/Article";
import {LoaderSpinner} from "../LoaderSpinner";
import "./magazine.css";
import MagazineListItem from "./MagazineListItem";
import {ApiResponse} from "../../../shared/models/ApiResponse";

interface MagazineAdminProps {
    limit: number,
    multi: boolean
}

enum Type {
    single = 0,
    multi = 1
}

export default function MagazinAdmin(props: MagazineAdminProps) {

    const [articles, setArticles] = useState<Article[]>();
    const [selected, setSelected] = useState<Article[]>([]);
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>();
    const [search, setSearch] = useState<string>('');
    const [searchTimeout, setSearchTimeout] = useState<number>(0);

    useEffect(() => {
        // standard avia form input element not shown, because react handle the articles
        document.getElementById("aviaTBarticles-form-container").setAttribute('style', 'display: none');
        const articles: string = document.getElementById("aviaTBarticles").getAttribute("value");
        if (articles) {
            const articleIds: string[] = articles.split(",");
            const articleIncIds: number[] = [];
            articleIds.map(value => {
                !isNaN(parseInt(value, 10)) && articleIncIds.push(parseInt(value, 10));
            });
            AppContext.magazineService.getArticles(articleIncIds, articleIds.length).then((resp: ApiResponse) => {
                if (resp.success) {
                    setSelected(resp.response.articles);
                }
            });
        }

    }, [])

    /**
     * search articles
     * @param find
     */
    const searchArticles = (find: string) => {
        setError('');
        setLoading(true);

        AppContext.magazineService.searchArticles(find, props.limit).then((resp: ApiResponse) => {
            setLoading(false);
            if (resp.success) {
                setArticles(resp.response.articles.sort((a: Article, b: Article) => {
                        return a.incId > b.incId ? 1 : -1;
                    }
                ));
            } else {
                setError('Beim Lesen der Artikel ist ein Fehler aufgetreten');
            }
        }).catch(reason => {
            setError('Beim Lesen der Artikel ist ein Fehler aufgetreten');
            setLoading(false);
            console.warn(reason);
        });
    }

    /**
     * set the article in state and in avia form element.
     * @param selectedArticles
     */
    const setArticleInAviaFormElement = (selectedArticles: Article[]) => {
        const articles: number[] = [];
        selectedArticles.map(article => articles.push(article.incId))
        document.getElementById("aviaTBarticles").setAttribute("value", articles.join(","));
        setSelected(JSON.parse(JSON.stringify(selectedArticles)));
    }

    return <div className={"magazine-admin"}>
        <div className={"avia-name-description"}>
            <strong>Artikel</strong>
        </div>
        <div className={"avia-form-element"}>

            {error ? (
                <div className={"error-message"}>
                    {error}
                </div>
            ) : (
                <div>
                    <input type={"text"} value={search} onChange={event => {
                        setSearch(event.target.value);
                        if (searchTimeout) {
                            clearTimeout(searchTimeout);
                            setSearchTimeout(0);
                        }

                        setSearchTimeout(window.setTimeout(function () {
                            searchArticles(this);
                        }.bind(event.target.value), 1000));
                    }}/>
                    <button className="button button-secondary button-large"
                            onClick={() => searchArticles(search)}>Artikel suchen
                    </button>
                    {selected && selected.length > 0 && (
                        <React.Fragment>
                            <div className={"avia-name-description headline"}>
                                <strong>{props.multi ? 'Ausgewählte' : "Ausgewählter Single Artikel"}</strong>
                            </div>
                            <ul className={"articles"}>
                                {selected.map((article: Article, index: number) => {
                                    return <MagazineListItem key={index} article={article}
                                                             buttonText={"Entfernen"}
                                                             onClick={() => {
                                                                 const selectedArticles = selected.filter((art: Article) => {
                                                                     return article.id !== art.id;
                                                                 })
                                                                 setArticleInAviaFormElement(selectedArticles);
                                                             }}/>
                                })}
                            </ul>
                        </React.Fragment>
                    )}
                    {loading ? (
                        <LoaderSpinner/>
                    ) : (
                        <React.Fragment>
                            {articles && articles.length > 0 && (
                                <React.Fragment>
                                    <div className={"avia-name-description headline"}>
                                        <strong>Suchergebnis</strong>
                                    </div>
                                    <ul className={"articles"}>
                                        {articles.map((article: Article, index: number) => {
                                            const match = selected.filter(value => value.id === article.id);
                                            return <React.Fragment key={index}>
                                                {!match || match.length === 0 && (
                                                    <MagazineListItem buttonText={"Hinzufügen"} article={article}
                                                                      onClick={() => {
                                                                          if (props.multi) {
                                                                              selected.push(article);
                                                                          } else {
                                                                              selected[0] = article;
                                                                          }
                                                                          setArticleInAviaFormElement(selected);
                                                                      }}/>
                                                )}
                                            </React.Fragment>;
                                        })}
                                    </ul>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}
                </div>
            )}
        </div>
    </div>;
}
